import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { useProcessContext } from '../store'
import FallbackCustomView from './FallbackCustomView'

const CustomView = ({
  id,
  config = {},
  tableContext,
  data = {},
  isPreview,
  fields = [],
  processId,
  isDashboardPreview,
  activityTypes,
}) => {
  const [LoadedView, setLoadedView] = useState(null)
  const processContext = useProcessContext((state) => state.processContext)
  const prefix = processContext?.activityTemplate?.prefix
  const activityType = processContext?.activityTemplate?.activity_type
  const process_reference_num = processContext?.processData?.process_reference_num
  const company_name = processContext?.companyDetails?.company_name

  const defaultValues = {
    prefix,
    process_reference_num,
    company_name,
    activityType,
    tableContext,
  }

  const valuesToUse =
    data && Object.keys(data).length > 0
      ? { ...data, ...defaultValues, current_process_reference_num: data.process_reference_num }
      : defaultValues

  const keyValuePairs = config?.props?.reduce((acc, cur) => {
    if (valuesToUse[cur] !== undefined) {
      acc[cur] = valuesToUse[cur]
    } else if (typeof cur == 'object') {
      acc = { ...acc, ...cur }
    }
    return acc
  }, {})

  useEffect(() => {
    const loadModules = async () => {
      try {
        const { default: MyModule } = await import(
          `./${config?.companyId}/${config?.component}/index.js`
        )
        setLoadedView(() => MyModule)
      } catch (error) {
        console.error(`Failed to load module MyModule from CompanyX:`, error)
        setLoadedView(() => () => <FallbackCustomView message="Module not available." />)
      }
    }

    loadModules()
  }, [config?.component, config?.companyId])

  const currentFieldConfig = React.useMemo(() => {
    return fields?.find((f) => f.id === id)
  }, [fields, id])
  return (
    <div className="preview-customview">
      <Box
        sx={{
          maxWidth: '100%',
          overflow: 'hidden',
          fontSize: '12px',
        }}
      >
        {LoadedView && (
          <LoadedView
            id={id}
            data={keyValuePairs}
            isPreview={isPreview}
            isDashboardPreview={isDashboardPreview}
            fields={fields}
            processId={processId}
            activityTypes={activityTypes}
            value={valuesToUse}
          />
        )}
      </Box>
    </div>
  )
}

export default CustomView
